import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { DateWrapper } from "../../Pages/CompetitiveIntelligence/ViewCompetitive.styled";


const parseDateVal = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  if (typeof dateStr !== 'string') return null;

  if (dateStr.includes('/')) {
    const parts = dateStr.split('/').map(Number);
    if (parts.length !== 3) return null;
    const [day, month, year] = parts;
    return new Date(year, month - 1, day);
  }

  if (dateStr.includes('-')) {
    const parts = dateStr.split('-').map(Number);
    if (parts.length !== 3) return null;
    if (String(parts[0]).length === 4) {
      const [year, month, day] = parts;
      return new Date(year, month - 1, day);
    }
    const [day, month, year] = parts;
    return new Date(year, month - 1, day);
  }
  return null;
};

const formatDateToYYYYMMDD = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export default function RangeSlider({
  is_active = false,
  startDate,
  endDate,
  selectedStartDate,
  selectedEndDate,
  setStartDateOne,
  setEndDateOne,
  onChange,
  topicCount,
}) {
  const [value, setValue] = useState([0, 1]);
  const [max, setMax] = useState(0);
  const [labels, setLabels] = useState([]);
  const [sliderDisabled, setSliderDisabled] = useState(false);

  useEffect(() => {
    const start = parseDateVal(startDate);
    const end = parseDateVal(endDate);
    if (!start || !end) {
      setMax(0);
      setValue([0, 1]);
      setLabels([]);
      setSliderDisabled(true);
      return;
    }

    const diffDays = Math.max(1, Math.floor((end - start) / (1000 * 60 * 60 * 24)));
    setMax(diffDays);
    setSliderDisabled(diffDays <= 0);

    const newLabels = diffDays > 8
      ? [
          start.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
          ...Array.from({ length: 5 }, (_, i) => {
            const date = new Date(start);
            date.setDate(start.getDate() + Math.round((diffDays * (i + 1)) / 6));
            return date.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
          }),
          end.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
        ]
      : Array.from({ length: diffDays + 1 }, (_, index) => {
          const date = new Date(start);
          date.setDate(start.getDate() + index);
          return date.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        });

    setLabels(newLabels);
    const selStart = parseDateVal(selectedStartDate) || start;
    const selEnd = parseDateVal(selectedEndDate) || end;
    const clamp = (val) => Math.min(Math.max(val, 0), diffDays);
    const startOffset = clamp(Math.round((selStart - start) / (1000 * 60 * 60 * 24)));
    const endOffset = clamp(Math.round((selEnd - start) / (1000 * 60 * 60 * 24)));
    setValue([Math.min(startOffset, endOffset), Math.max(startOffset, endOffset)]);
  }, [startDate, endDate, selectedStartDate, selectedEndDate]);

  const handleSliderChange = (event, newValue) => {
    if (!Array.isArray(newValue)) return;
    if (is_active === true) {
      setValue([newValue[0], max]);
    }else{
      setValue(newValue);
    }
  };

  const handleSliderCommitted = (event, newValue) => {
    if (!Array.isArray(newValue)) return;
    const start = parseDateVal(startDate);
    if (!start) return;

    const newStartDate = new Date(start.getTime() + newValue[0] * 24 * 60 * 60 * 1000);
    const newEndDate = new Date(start.getTime() + newValue[1] * 24 * 60 * 60 * 1000);
    const startValue = newStartDate.toLocaleDateString('en-GB');
    const endValue = newEndDate.toLocaleDateString('en-GB');

    setStartDateOne(startValue);
    setEndDateOne(endValue);
    if (typeof onChange === 'function') {
      onChange({ startDate: startValue, endDate: endValue, topicCount });
    }
  };
  return (
    <Box sx={{ margin: '0 auto', textAlign: 'center' }}>
      <div style={{ marginTop: 10, borderRadius: 4, border: '1px solid rgba(162, 162, 162, 1)' }}>
        <Box sx={{ width: '90%', padding: '20px', margin: '0 auto', textAlign: 'center' }}>
          <Slider
            disabled={sliderDisabled}
            getAriaLabel={() => 'Date range'}
            value={value}
            onChange={handleSliderChange}
            onChangeCommitted={handleSliderCommitted}
            valueLabelDisplay='auto'
            valueLabelFormat={(val) => {
              const start = parseDateVal(startDate);
              if (!start) return '';
              const newDate = new Date(start.getTime() + val * 24 * 60 * 60 * 1000);
              return newDate.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
            }}
            max={max}
            marks={labels.map((label, index) => ({
              value: Math.round((max * index) / Math.max(1, labels.length - 1)),
              label,
            }))}

            sx={{
              "& .MuiSlider-track": {
                bgcolor: 'rgba(23, 120, 102, 1)',
                height: "20px",
                border: "1px solid rgba(23, 120, 102, 1)",
              },
              "& .MuiSlider-thumb": {
                bgcolor: "white",
                border: "2px solid rgba(162, 162, 162, 1)",
                height: "30px",
                width: "30px",
              },
              "& .MuiSlider-rail": {
                bgcolor: "rgba(242, 242, 242, 1)",
                height: "20px",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRadius: '0px'
              },
              "& .MuiSlider-markLabel": {
                color: "#555",
                fontSize: "14px",
                marginTop: "10px",
                fontFamily:'Inter'
              },
              "& .MuiSlider-mark": {
                display: "none",
              },
            }}
          />
        </Box>


      </div>

      {/* <DateWrapper>
        <div>
          <div style={{
            textAlign: 'left',
            marginBottom: '7px',
            marginLeft: '8px',
            marginTop: '20px'
          }}>Start Date:</div>
          <input
            type="date"
            name="firstPostDate"
            value={startInput}
            onChange={handleStartInputChange}
            style={{
              width: "150px",
              height: "40px",
              borderRadius: "8px",
              border: "1px solid rgb(217, 217, 217)",
              background: "rgb(255, 255, 255)",
              boxShadow: "rgba(162, 162, 162, 0.24) 0px 0px 8px 0px",
              padding: "1px 8px",
              color: "rgb(99, 99, 99)",
              fontFamily: "Open Sans",
              fontSize: "15px",
              fontStyle: "normal",
              fontWeight: "400",
            }}

            min={formatDateToDDMMYYYY(startDate)}
            max={formatDateToDDMMYYYY(endDate)}
          />
        </div>
        <div>
          <div style={{
            textAlign: 'left',
            marginBottom: '7px',
            marginLeft: '8px',
            marginTop: '20px'
          }}>End Date:</div>
          <input
            type="date"
            name="endPostDate"
            value={endInput}
            onChange={handleEndInputChange}
            style={{
              width: "150px",
              height: "40px",
              borderRadius: "8px",
              border: "1px solid rgb(217, 217, 217)",
              background: "rgb(255, 255, 255)",
              boxShadow: "rgba(162, 162, 162, 0.24) 0px 0px 8px 0px",
              padding: "1px 8px",
              color: "rgb(99, 99, 99)",
              fontFamily: "Open Sans",
              fontSize: "15px",
              fontStyle: "normal",
              fontWeight: "400",
            }}
            min={formatDateToDDMMYYYY(startDate)}
            max={formatDateToDDMMYYYY(endDate)}
          />
        </div>
      </DateWrapper> */}
    </Box>
  );
}
